const processInclude = require("base/util");

export default function () {
    processInclude(require("base/components/collapsibleItem"));

    /**
     * Toggle once functionality for collapse
     */
    const toggleOnce = "toggle-once";
    if ($(".collapse").hasClass(toggleOnce)) {
        $("." + toggleOnce).on("show.bs.collapse", (e) => {
            const $collapse = $(e.target);
            $collapse.parent().find("*[data-toggle='collapse']").removeAttr("data-toggle");
            $collapse.removeClass(toggleOnce);
        });
    }
}
